import { render, staticRenderFns } from "./UiFormDivider.vue?vue&type=template&id=d9fa4268&scoped=true"
import script from "./UiFormDivider.vue?vue&type=script&lang=js"
export * from "./UiFormDivider.vue?vue&type=script&lang=js"
import style0 from "./UiFormDivider.vue?vue&type=style&index=0&id=d9fa4268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fa4268",
  null
  
)

export default component.exports